import React from "react";
import {IFlightSearchControllerViewModel} from "../../../services/flight-search/flight-search-controller/flight-search-controller-view-model.interface";
import {IServiceFactory} from "../../../services/service-factory.interface";
import styled from "styled-components";
import {HORIZONTAL_SPACING_PX} from "../../css-global-constants";
import {ArrowsRightLeftIcon} from "../../../assets/svg/arrows-right-left.icon";
import {QuestionMarkIcon} from "../../../assets/svg/question-mark,icon";

const SelectedDatesBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
`

const ArrowsBox = styled.div`
    margin: 0 ${HORIZONTAL_SPACING_PX} 0 ${HORIZONTAL_SPACING_PX};
`

export function composeFlightDatesDropDownHeaderTitle(searchController: IFlightSearchControllerViewModel, services: IServiceFactory): React.ReactElement | string {
    const fields = searchController.fields;
    const departureDate = services.time.formatUserFriendlyDate(fields.departureDate.value)
    const returnDate = services.time.formatUserFriendlyDate(fields.returnDate.value)
    if(searchController.isOneWay) {
        if(departureDate) {
            return departureDate;
        } else {
            return services.language.translate('Select the departure date');
        }
    } else {
        if(!departureDate && !returnDate) {
            return services.language.translate('Select the flights dates');
        } else {
            return (
                <SelectedDatesBox>
                    <div>
                        {departureDate || <QuestionMarkIcon/>}
                    </div>
                    <ArrowsBox>
                        <ArrowsRightLeftIcon/>
                    </ArrowsBox>
                    <div>
                        {returnDate || <QuestionMarkIcon/>}
                    </div>
                </SelectedDatesBox>
            )
        }
    }
}
